/**
 * Resolve a sigla de tipo de pedido exibida na coluna "TP" das listagens de pedidos.
 */
export function resolveTipoPedido(pedido, variant = 'acesso') {
  if (pedido?.tipoPedido === 0) return 'N';

  if (variant === 'ponto') {
    const tipoAtualizacao = (pedido?.tipoAtualizacao || 'A').toString().toUpperCase();
    return tipoAtualizacao;
  }

  return 'A';
}

